import './index.styl';
import template from './index.jst';
import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import _ from 'lodash';

const tippingChannel = Radio.channel( 'tipping' );

export default class TippingTipsDetails extends View {
	get template() {
		return template;
	}

	className() {
		return 'tipping-tip-details-inner';
	}

	initialize() {
		this.listenTo(tippingChannel, 'change:round', this.updateModel);
		this.listenTo(tippingChannel, 'tips:count', this.onReceiveNewData);
		this.listenTo(this.model, 'change', this.render);
		this.model.getData();
	}

	onReceiveNewData(args) {
		this.model.set(args);

		return this;
	}


	async updateModel( round_obj ) {
		let round = _.result( round_obj, 'round_id' );

		await this.model.getData({ data: { round } });

		this.render();
	}
}